/**
 * This empty function serves as a safe upcast mechanism.
 *
 * See https://github.com/microsoft/TypeScript/issues/47920 to learn more.
 *
 * @param val The value to upcast.
 */
export const upcast = <T>(val: T): T => val;
